import React from "react";

function Header() {
  return <h1 className={`font-bold text-5xl`}>Press the button</h1>;
}

export default Header;
